// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu__3rpXu","embedded":"embedded__2hy_u","bottom":"bottom__1zrjV","top":"top__2B8HR"};